<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Lịch sử chỉnh sửa bảng công</h4>
          </div>
          <div class="text-right">
            <el-button
              @click="fn_tableShowFormSearch()"
              type="info"
              round
              class="btn-default"
            >Ẩn/hiện tìm kiếm</el-button>
          </div>
        </div>

        <div class="main-body mt-1">
          <div class="main-body-search mb-2 b-shadow">
            <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
              <b-card>
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  :model="mData.tableRules.dataSearch.value"
                >
                  <b-row>
                    <b-col md="10">
                      <el-form-item label="Điều kiện">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value.condition"
                          placeholder="Nhập Mã nhân viên, Họ và tên, Số điện thoại"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="2" class="d-flex align-items-end pb-1">
                      <el-button
                        round
                        native-type="submit"
                        @click="fn_tableSearch()"
                        class="btn-default w-100"
                        type="primary"
                      >Tìm kiếm</el-button>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Công ty">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.company_id"
                          clearable
                          filterable
                          placeholder="Tất cả công ty"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listCompany"
                            :key="item.id"
                            :label="item.name && item.name.name_vi ? item.name.name_vi : item.id"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Cách thức thay đổi">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.change_source"
                          clearable
                          placeholder="Tất cả"
                          style="width: 100%"
                        >
                          <el-option label="Trực tiếp"      value="DIRECT"></el-option>
                          <el-option label="Giải trình công" value="EXPLANATION"></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Ngày thay đổi từ">
                        <el-date-picker
                          v-model="mData.tableRules.dataSearch.value.changed_at_from"
                          type="date"
                          placeholder="Từ ngày"
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          style="width: 100%"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Ngày thay đổi đến">
                        <el-date-picker
                          v-model="mData.tableRules.dataSearch.value.changed_at_to"
                          type="date"
                          placeholder="Đến ngày"
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          style="width: 100%"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Ngày công từ">
                        <el-date-picker
                          v-model="mData.tableRules.dataSearch.value.target_work_date_from"
                          type="date"
                          placeholder="Từ ngày"
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          style="width: 100%"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Ngày công đến">
                        <el-date-picker
                          v-model="mData.tableRules.dataSearch.value.target_work_date_to"
                          type="date"
                          placeholder="Đến ngày"
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          style="width: 100%"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-form>
              </b-card>
            </b-collapse>
          </div>

          <div class="main-body-table">
            <el-table :data="mData.tableRules.data" border style="width: 100%">
              <el-table-column label="STT" width="55" align="center">
                <template slot-scope="scope">
                  {{ mData.tableRules.offset + scope.$index + 1 }}
                </template>
              </el-table-column>

              <el-table-column label="Họ và tên người sửa" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ fn_getChangedByName(scope.row) }}
                </template>
              </el-table-column>

              <el-table-column label="Người được sửa" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.target_employee && scope.row.target_employee.full_name || "-" }}
                </template>
              </el-table-column>

              <el-table-column label="Ngày công" width="115" align="center">
                <template slot-scope="scope">
                  {{ fn_formatDate(scope.row.target_work_date) }}
                </template>
              </el-table-column>

              <el-table-column label="Thay đổi từ" width="130" align="center">
                <template slot-scope="scope">
                  {{
                    scope.row.change_source === "DIRECT"      ? "Trực tiếp" :
                    scope.row.change_source === "EXPLANATION" ? "Giải trình công" : "-"
                  }}
                </template>
              </el-table-column>

              <el-table-column label="Ngày thay đổi" min-width="155" align="center">
                <template slot-scope="scope">
                  {{ fn_formatDateTime(scope.row.changed_at) }}
                </template>
              </el-table-column>

              <el-table-column label="Giá trị cũ" width="100" align="center">
                <template slot-scope="scope">
                  {{ scope.row.old_work_value !== null && scope.row.old_work_value !== undefined ? scope.row.old_work_value : "-" }}
                </template>
              </el-table-column>

              <el-table-column label="Giá trị mới" width="100" align="center">
                <template slot-scope="scope">
                  {{ scope.row.new_work_value !== null && scope.row.new_work_value !== undefined ? scope.row.new_work_value : "-" }}
                </template>
              </el-table-column>
            </el-table>

            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-4"></div>
              <div class="col-md-8 text-right">
                <el-pagination
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from "../../../../../service/MethodService";
import WorkChangeHistoryModel from "./WorkChangeHistoryModel";
import WorkChangeHistoryApi from "../../../../../moduleApi/WorkChangeHistoryApi";
import CompanyApi from "../../../../../moduleApi/CompanyApi";

export default {
  data() {
    return {
      mData: {
        moduleName: "WorkChangeHistory",
        tableRules: MethodService.copyObject(WorkChangeHistoryModel.tableRules),
        dataDefault: {
          listCompany: [],
        },
      },
    };
  },

  methods: {
    fn_canAccess() {
      const codes = ["FT901", "FT902", "FT1001", "FT1003", "FT1004", "FT1006", "FT1007"];
      return codes.some((code) => MethodService.checkHaveFeature(code));
    },

    fn_formatDate(dateStr) {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      if (isNaN(d) || d.getFullYear() < 2000) return "-";
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
    },

    fn_formatDateTime(dateStr) {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      if (isNaN(d)) return dateStr;
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    fn_getChangedByName(row) {
      if (row && row.changed_by_employee && row.changed_by_employee.full_name) {
        return row.changed_by_employee.full_name;
      }
      const company = this.mData.dataDefault.listCompany.find((item) => item.id === row.company_id);
      if (!company) {
        return "-";
      }
      return company.representative && company.representative.name
        ? company.representative.name
        : "-";
    },

    async fn_initDataDefault() {
      const currentUser = MethodService.getCurrentUser();
      const res = await CompanyApi.list(
        await MethodService.applyScopeFilter({ limit: 200 }, currentUser, true)
      );
      if (res && res.result) {
        this.mData.dataDefault.listCompany = res.result;
      }
    },

    async fn_initTable() {
      if (!this.fn_canAccess()) {
        window.toastr.warning("Bạn không có quyền xem lịch sử chỉnh sửa bảng công");
        return;
      }

      const f = this.mData.tableRules.activeFilters || {};
      const dataFilter = {
        limit:                 this.mData.tableRules.limit,
        offset:                this.mData.tableRules.offset,
        sort:                  this.mData.tableRules.sort,
        vn_text:               f.vn_text               || undefined,
        company_id:            f.company_id            || undefined,
        change_source:         f.change_source         || undefined,
        changed_at_from:       f.changed_at_from       || undefined,
        changed_at_to:         f.changed_at_to         || undefined,
        target_work_date_from: f.target_work_date_from || undefined,
        target_work_date_to:   f.target_work_date_to   || undefined,
      };

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-Timekeeping-TimekeepingConfig-WorkChangeHistory-list",
          query: {
            limit:          this.mData.tableRules.limit,
            page:           this.mData.tableRules.page,
            sort:           this.mData.tableRules.sort,
            showFormSearch: this.mData.tableRules.showFormSearch,
          },
        }).catch(() => {});
      }

      let res;
      try {
        res = await WorkChangeHistoryApi.list(dataFilter);
      } catch (e) {
        window.toastr.error(e && e.detail ? e.detail : "Không thể tải dữ liệu");
        return;
      }
      if (!res || !res.result) return;

      this.mData.tableRules.data  = res.result;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page  = res.meta.offset / res.meta.limit + 1;
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules.showFormSearch;
    },

    fn_tableSearch() {
      const s = this.mData.tableRules.dataSearch.value;
      this.mData.tableRules.activeFilters = {
        vn_text:               s.condition             ? s.condition.trim() : "",
        company_id:            s.company_id            || "",
        change_source:         s.change_source         || "",
        changed_at_from:       s.changed_at_from       || "",
        changed_at_to:         s.changed_at_to         || "",
        target_work_date_from: s.target_work_date_from || "",
        target_work_date_to:   s.target_work_date_to   || "",
      };
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.page   = 1;
      this.fn_initTable();
    },

    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) { this.fn_tableChangeOffset(page); },
    fn_tablePrevClick(page)    { this.fn_tableChangeOffset(page); },
    fn_tableNextClick(page)    { this.fn_tableChangeOffset(page); },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page   = page;
      this.mData.tableRules.offset = (page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page   = parseInt(this.$route.query.page);
        this.mData.tableRules.offset = (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
      }
      if (this.$route.query.showFormSearch === "true") {
        this.mData.tableRules.showFormSearch = true;
      }
    },
  },

  async created() {
    await this.fn_hashUrl();
    await this.fn_initDataDefault();
    await this.fn_initTable();
  },
};
</script>

<style scoped>
::v-deep .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 5px;
}
</style>
